import React, { useState, useEffect } from "react";
import classes from './Settings.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import api from "../../Components/API/Api";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const Settings = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [metrics, setMetrics] = useState({
        total: 0,
        active: 0,
        inactive: 0,
    });

    const [loading, setLoading] = useState(false);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadingProducts, setUploadingProducts] = useState(false);
    const [stockClassifications, setStockClassifications] = useState([]);
    const [stockCategories, setStockCategories] = useState([]);
    const [stores, setStores] = useState([]);
    const [incomeAccounts, setIncomeAccounts] = useState([]);
    const [cogsAccounts, setCogsAccounts] = useState([]);
    const [payableAccounts, setPayableAccounts] = useState([]);
    const [receivableAccounts, setReceivableAccounts] = useState([]);
    const [selectedStore, setSelectedStore] = useState(() => {
        return (
            localStorage.getItem("store_id") ||
            localStorage.getItem("storeId") ||
            ""
        );
    });
    const [selectedType, setSelectedType] = useState(() => {
        return localStorage.getItem("upload_stock_type") || "2";
    });
    const [selectedIncomeAccount, setSelectedIncomeAccount] = useState(() => {
        return localStorage.getItem("income_account") || "";
    });
    const [selectedCogsAccount, setSelectedCogsAccount] = useState(() => {
        return localStorage.getItem("cost_of_good_gl") || "";
    });
    const [selectedPayableAccount, setSelectedPayableAccount] = useState(() => {
        return localStorage.getItem("payable_gl") || "";
    });
    const [selectedReceivableAccount, setSelectedReceivableAccount] = useState(() => {
        return localStorage.getItem("account_receivable") || "";
    });
    const [selectedClassification, setSelectedClassification] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    useEffect(() => {
        fetchStocks();
        fetchMetrics();
        fetchStockMetadata();
        fetchStores();
        fetchAccountOptions();
    }, []);

    const fetchAccountOptions = async () => {
        try {
            const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

            const unwrapList = (res) =>
                Array.isArray(res?.data?.data)
                    ? res.data.data
                    : Array.isArray(res?.data)
                    ? res.data
                    : Array.isArray(res?.data?.accounts)
                    ? res.data.accounts
                    : [];

            const fetchList = async (url, withCompanyParam = true) => {
                try {
                    const res = await api.get(url, withCompanyParam ? { params: { company_id: companyId } } : undefined);
                    return unwrapList(res);
                } catch (err) {
                    return [];
                }
            };

            const [incomeList, cogsList] = await Promise.all([
                fetchList(`/v1/get-income-accounts`),
                fetchList(`/v1/get-expense-accounts`),
            ]);

            let payableList = await fetchList(`/v1/get-payable-accounts`, true);
            if (!payableList.length) {
                payableList = await fetchList(`/v1/get-payable-accounts`, false);
            }

            let receivableList = await fetchList(`/v1/get-receivable-accounts`, true);
            if (!receivableList.length) {
                receivableList = await fetchList(`/v1/get-receivable-accounts`, false);
            }
            if (!receivableList.length) {
                receivableList = await fetchList(`/v1/get-receivables-accounts`, false);
            }

            setIncomeAccounts(incomeList);
            setCogsAccounts(cogsList);
            setPayableAccounts(payableList);
            setReceivableAccounts(receivableList);

            setSelectedIncomeAccount((prev) => prev || String(incomeList[0]?.id || ""));
            setSelectedCogsAccount((prev) => prev || String(cogsList[0]?.id || ""));
            setSelectedPayableAccount((prev) => prev || String(payableList[0]?.id || ""));
            setSelectedReceivableAccount((prev) => prev || String(receivableList[0]?.id || ""));
        } catch (error) {
            console.error("Error fetching account options:", error);
        }
    };

    const fetchStores = async () => {
        try {
            const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

            const res = await api.get(`/v1/store`, {
                params: { company_id: companyId },
            });

            if (res?.data?.data && Array.isArray(res.data.data)) {
                setStores(res.data.data);

                // if no selected store, pick from localStorage or first store returned
                if (!selectedStore) {
                    const fallback =
                        localStorage.getItem("store_id") || localStorage.getItem("storeId") || (res.data.data[0] && res.data.data[0].id);
                    if (fallback) setSelectedStore(String(fallback));
                }
            }
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

    const fetchStocks = async () => {
        setLoading(true);

        try {
            const res = await api.get(`/v1/fetch_stocks`);

            if (Array.isArray(res.data?.data)) {
                setData(res.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching stocks:", error);
        }

        setLoading(false);
    };

    const fetchMetrics = async () => {
        try {
            const res = await api.get(`/v1/stock_metrics`);

            if (res.data?.data) {
                setMetrics({
                    total: res.data.data.total_stock || 0,
                    active: res.data.data.active_stock || 0,
                    inactive: res.data.data.inactive_stock || 0,
                });
            }
        } catch (error) {
            console.error("Error fetching stock metrics:", error);
        }
    };

    const fetchStockMetadata = async () => {
        try {
            const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

            const [classRes, categoryRes] = await Promise.all([
                api.get(`/v1/fetch_stock_classification`, {
                    params: { company_id: companyId },
                }),
                api.get(`/v1/stock_category`, {
                    params: { company_id: companyId },
                }),
            ]);

            if (classRes?.data?.data && Array.isArray(classRes.data.data)) {
                setStockClassifications(classRes.data.data);
            }

            if (categoryRes?.data?.data && Array.isArray(categoryRes.data.data)) {
                setStockCategories(categoryRes.data.data);
            }
        } catch (error) {
            console.error("Error fetching stock metadata:", error);
        }
    };

    const handleOpenUploadModal = () => {
        setIsUploadModalOpen(true);
    };

    const handleCloseUploadModal = () => {
        setIsUploadModalOpen(false);
        setUploadFile(null);
        setUploadingProducts(false);
        setSelectedStore(localStorage.getItem("store_id") || localStorage.getItem("storeId") || "");
        setSelectedType(localStorage.getItem("upload_stock_type") || "2");
        setSelectedIncomeAccount(localStorage.getItem("income_account") || "");
        setSelectedCogsAccount(localStorage.getItem("cost_of_good_gl") || "");
        setSelectedPayableAccount(localStorage.getItem("payable_gl") || "");
        setSelectedReceivableAccount(localStorage.getItem("account_receivable") || "");
        setSelectedClassification("");
        setSelectedCategory("");
    };

    const handleDownloadTemplate = async () => {
        try {
            const response = await api.get(`/v1/download-product-template`, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], {
                type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = 'products_template.xlsx';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading template:', error);
            Swal.fire({
                icon: 'error',
                title: 'Download failed',
                text: 'Unable to download the template. Please try again.',
            });
        }
    };

    const handleFileSelection = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            setUploadFile(null);
            return;
        }

        const validTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
            "text/csv",
        ];

        if (!validTypes.includes(file.type) && !/\.(xlsx|xls|csv)$/i.test(file.name)) {
            Swal.fire({
                icon: "error",
                title: "Invalid file format",
                text: "Please upload an Excel file (.xlsx, .xls) or CSV file.",
            });
            setUploadFile(null);
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            Swal.fire({
                icon: "error",
                title: "File too large",
                text: "Please upload a file smaller than 5MB.",
            });
            setUploadFile(null);
            return;
        }

        setUploadFile(file);
    };

    const parseExcelRows = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (rows.length < 2) {
                    reject(new Error("The uploaded file must contain a header row and at least one product row."));
                    return;
                }

                const headers = rows[0].map((header) => header?.toString().trim() || "");
                const dataRows = rows.slice(1);

                const normalizeHeader = (value) =>
                    value.toString().trim().toLowerCase().replace(/[^a-z0-9]/g, "");

                const headerMapping = {
                    type: "type",
                    itemtype: "type",
                    item_type: "type",
                    product: "type",
                    service: "type",
                    name: "name",
                    productname: "name",
                    productservicename: "name",
                    servicename: "name",
                    shortname: "short_name",
                    short: "short_name",
                    code: "short_name",
                    sku: "short_name",
                    description: "description",
                    desc: "description",
                    stockclassification: "stock_classification",
                    classification: "stock_classification",
                    class: "stock_classification",
                    stockcategory: "stock_category",
                    category: "stock_category",
                    quantity: "quantity",
                    qty: "quantity",
                    amount: "quantity",
                    price: "unit_price",
                    pricerate: "unit_price",
                    unitprice: "unit_price",
                    cost: "unit_price",
                    unitofmeasurement: "unit_of_measurement",
                    uom: "unit_of_measurement",
                    measurement: "unit_of_measurement",
                    reorderlevel: "re_order_level",
                    reorder: "re_order_level",
                    minlevel: "re_order_level",
                    minimum: "re_order_level",
                };

                const products = dataRows
                    .map((row) => {
                        const item = {};

                        headers.forEach((header, index) => {
                            const mappedField = headerMapping[normalizeHeader(header)];

                            if (mappedField && row[index] !== undefined && row[index] !== null && row[index] !== "") {
                                item[mappedField] = row[index];
                            }
                        });

                        return item;
                    })
                    .filter((item) => item.name || item.short_name || item.description);

                if (products.length === 0) {
                    reject(new Error("No valid products were found in the uploaded file."));
                    return;
                }

                resolve(products);
            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = () => reject(new Error("Failed to read the selected file."));
        reader.readAsArrayBuffer(file);
    });

    const getMappedOptionId = (value, options) => {
        if (!value && value !== 0) return "";

        const normalizedValue = String(value).trim().toLowerCase();

        const match = options.find((option) => {
            const optionName = String(option?.name || option?.label || option?.title || "").trim().toLowerCase();
            const optionId = String(option?.id || option?.value || "").trim().toLowerCase();

            return optionName === normalizedValue || optionId === normalizedValue;
        });

        return match?.id || match?.value || "";
    };

    const handleSubmitUploadedProducts = async () => {
        if (!uploadFile) {
            Swal.fire({
                icon: "warning",
                title: "No file selected",
                text: "Choose an Excel or CSV file before submitting.",
            });
            return;
        }

        setUploadingProducts(true);

        try {
            const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
            const formData = new FormData();

            formData.append("file", uploadFile);

            if (companyId) {
                formData.append("company_id", String(companyId));
            }

            // Required: type (1 = Service, 2 = Product). Default to Product (2).
            const selectedTypeValue = selectedType || localStorage.getItem("upload_stock_type") || "2";
            formData.append("type", String(selectedTypeValue));

            // Include store from the modal selection (required by API) or fallback to localStorage
            const storeId = selectedStore || localStorage.getItem("store_id") || localStorage.getItem("storeId");
            if (storeId) {
                formData.append("store_id", String(storeId));
            }

            if (selectedClassification) {
                formData.append("stock_classification", String(selectedClassification));
            }

            if (selectedCategory) {
                formData.append("stock_category", String(selectedCategory));
            }

            if (selectedIncomeAccount) {
                formData.append("income_account", String(selectedIncomeAccount));
            }

            if (selectedCogsAccount) {
                formData.append("cost_of_good_gl", String(selectedCogsAccount));
            }

            if (selectedPayableAccount) {
                formData.append("payable_gl", String(selectedPayableAccount));
            }

            if (selectedReceivableAccount) {
                formData.append("account_receivable", String(selectedReceivableAccount));
            }

            const inventoryGl = localStorage.getItem("inventory_gl");
            if (inventoryGl) formData.append("inventory_gl", String(inventoryGl));

            const payableGl = localStorage.getItem("payable_gl");
            if (payableGl) formData.append("payable_gl", String(payableGl));

            const accountReceivable = localStorage.getItem("account_receivable");
            if (accountReceivable) formData.append("account_receivable", String(accountReceivable));

            const response = await api.post(`/v1/upload_stocks`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response?.data?.status === false) {
                throw new Error(response?.data?.message || "One or more products could not be uploaded.");
            }

            Swal.fire({
                icon: "success",
                title: "Products uploaded",
                text: "Your Excel sheet has been submitted for bulk product creation.",
            });
            handleCloseUploadModal();
            fetchStocks();
            fetchMetrics();
        } catch (error) {
            console.error("Error uploading products:", error);
            Swal.fire({
                icon: "error",
                title: "Upload failed",
                text: error?.message || "An unexpected issue occurred while uploading products.",
            });
        } finally {
            setUploadingProducts(false);
        }
    };

    // Pagination Logic
    const totalPages = Math.ceil(data.length / rowsPerPage);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        setSelectedRows([]);
    };

    // Select All
    const allSelected =
        currentRows.length > 0 &&
        currentRows.every((_, index) =>
            selectedRows.includes(indexOfFirstRow + index)
        );

    const handleSelectAll = () => {
        const currentPageIndexes = currentRows.map(
            (_, index) => indexOfFirstRow + index
        );

        if (allSelected) {
            setSelectedRows((prev) =>
                prev.filter((row) => !currentPageIndexes.includes(row))
            );
        } else {
            setSelectedRows((prev) => [
                ...new Set([...prev, ...currentPageIndexes]),
            ]);
        }
    };

    const handleSelectRow = (index) => {
        setSelectedRows((prev) =>
            prev.includes(index)
                ? prev.filter((row) => row !== index)
                : [...prev, index]
        );
    };

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return "";

        return `₦${Number(amount).toLocaleString("en-NG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    const handleEditProduct = (product) => {
        navigate(`/settings/products&services/new-items/add-product`, {
            state: { product, isEdit: true }
        });
    };

    const handleDeleteProduct = (productId) => {
        if (window.confirm("Are you sure you want to delete this product?")) {
            setLoading(true);

            api.delete(`/v1/delete_stock/${productId}`)
                .then(() => {
                    setData((prev) =>
                        prev.filter((item) => item.id !== productId)
                    );

                    alert("Product deleted successfully");
                })
                .catch((error) => {
                    console.error("Error deleting product:", error);
                    alert("Failed to delete product");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>

                {/* Top Buttons */}
                <div className={classes.actions}>
                    <button
                        className={classes.btns}
                        onClick={() => navigate("/transactions/sales-invoice/sale")}
                    >
                        Sales Invoice
                    </button>

                    <button
                        className={classes.btns}
                        onClick={() => navigate("/inventory/purchaseOrder")}
                    >
                        Purchase Invoice
                    </button>

                    <button
                        className={classes.btns}
                        onClick={() => navigate("/inventory/stocks_delivery")}
                    >
                        Stock Delivery
                    </button>

                    <button className={`${classes.btnss} ${classes.greens}`}>
                        Product & Services
                    </button>
                </div>

                {/* Header */}
                <header className={classes.Header}>
                    <h2 className={classes.Title}>Product and Services</h2>

                    <h1 className={classes.Titles}>
                        Manage your products and services catalog for invoicing and inventory tracking.
                    </h1>
                </header>

                {/* Metrics */}
                <div className={classes.entrjj}>
                    <div className={classes.allkads}>

                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.total}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total Items</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.active}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Active Items</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>{metrics.inactive}</p>

                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Inactive Items</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Search */}
                <div className={classes.headerActions}>
                    <p className={classes.actionsLeft}>
                        {selectedRows.length} selected
                    </p>

                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <input
                                type="text"
                                className={classes.searchBar}
                                placeholder="Search..."
                            />

                            <img
                                src={searchicon}
                                alt="Search"
                                className={classes.inputIconGreen}
                            />
                        </div>

                        <div className={classes.inputWrapper}>
                            <input
                                type="text"
                                className={classes.searchBar}
                                placeholder="Filter..."
                            />

                            <img
                                src={filter}
                                alt="Filter"
                                className={classes.inputIcon}
                            />
                        </div>

                        <button
                            className={classes.btnss}
                            onClick={() =>
                                navigate("/settings/products&services/new-items/add-product")
                            }
                        >
                            + Add Products
                        </button>

                        <button
                            className={classes.btnssSecondary}
                            onClick={handleOpenUploadModal}
                        >
                            Upload Products
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={allSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>

                                <th>Code</th>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Store</th>
                                <th>Classification</th>
                                <th>Category</th>
                                <th>Type</th>
                                <th>Sales Price</th>
                                <th>Stock</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                Array.from({ length: 5 }).map((_, i) => (
                                    <tr key={i}>
                                        {Array.from({ length: 10 }).map((_, j) => (
                                            <td key={j}>
                                                <div className={classes.skeleton}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : currentRows.length > 0 ? (
                                currentRows.map((item, i) => {
                                    const realIndex = indexOfFirstRow + i;

                                    return (
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(realIndex)}
                                                    onChange={() =>
                                                        handleSelectRow(realIndex)
                                                    }
                                                />
                                            </td>

                                            <td>{realIndex + 1}</td>

                                            <td>{item.name}</td>

                                            <td>{item.description || "—"}</td>

                                            <td>{item.store?.store_name || "—"}</td>

                                            <td>{item.classification?.name || "—"}</td>

                                            <td>{item.category?.name || "—"}</td>

                                            <td>
                                                {item.type === "1" || item.type === 1
                                                    ? "Service"
                                                    : item.type === "2" || item.type === 2
                                                    ? "Product"
                                                    : "—"}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                                {formatCurrency(item.price)}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                                {item.quantity}
                                            </td>

                                            <td>
                                                <span className={classes.activeStatus}>
                                                    {item.status === "1"
                                                        ? "Active"
                                                        : "Inactive"}
                                                </span>
                                            </td>

                                            <td style={{ position: "relative" }}>
                                                <button
                                                    className={classes.menuButton}
                                                    onClick={() =>
                                                        setOpenMenuIndex(
                                                            openMenuIndex === realIndex
                                                                ? null
                                                                : realIndex
                                                        )
                                                    }
                                                >
                                                    ⋮
                                                </button>

                                                {openMenuIndex === realIndex && (
                                                    <div className={classes.dropdownMenu}>
                                                        <button
                                                            className={classes.menuItem}
                                                            onClick={() => {
                                                                handleEditProduct(item);
                                                                setOpenMenuIndex(null);
                                                            }}
                                                        >
                                                            Edit
                                                        </button>

                                                        <button
                                                            className={classes.menuItem}
                                                            onClick={() => {
                                                                handleDeleteProduct(item.id);
                                                                setOpenMenuIndex(null);
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan="12"
                                        style={{ textAlign: "center" }}
                                    >
                                        No products/services found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>

                            <td
                                style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
                                onClick={() =>
                                    currentPage > 1 &&
                                    handlePageChange(currentPage - 1)
                                }
                            >
                                Prev
                            </td>

                            {Array.from({ length: totalPages }, (_, i) => (
                                <td
                                    key={i}
                                    className={`${classes.page} ${
                                        currentPage === i + 1
                                            ? classes.activePage
                                            : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </td>
                            ))}

                            <td
                                style={{
                                    cursor:
                                        currentPage === totalPages
                                            ? "not-allowed"
                                            : "pointer"
                                }}
                                onClick={() =>
                                    currentPage < totalPages &&
                                    handlePageChange(currentPage + 1)
                                }
                            >
                                Next
                            </td>

                        </tr>
                    </tfoot>
                </table>

                {/* Display */}
                <div className={classes.paginationDisplay}>
                    Displaying {indexOfFirstRow + 1} -{" "}
                    {Math.min(indexOfLastRow, data.length)} of {data.length}
                </div>
            </div>

            {isUploadModalOpen && (
                <div className={classes.modalOverlay} onClick={handleCloseUploadModal}>
                    <div className={classes.modalCard} onClick={(event) => event.stopPropagation()}>
                        <div className={classes.modalHeader}>
                            <div>
                                <h3 className={classes.modalTitle}>Upload Products</h3>
                                <p className={classes.modalSubtitle}>
                                    Download the template, fill in your products, and upload the completed sheet.
                                </p>
                            </div>

                            <button className={classes.modalCloseButton} onClick={handleCloseUploadModal}>
                                ×
                            </button>
                        </div>

                        <div className={classes.modalBody}>
                            <div className={classes.uploadGrid}>
                                <button className={classes.templateButton} onClick={handleDownloadTemplate}>
                                    Download Excel Template
                                </button>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Select Store</span>
                                    <select
                                        value={selectedStore}
                                        onChange={(e) => setSelectedStore(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select store --</option>
                                        {stores.map((s) => (
                                            <option key={s.id} value={s.id}>
                                                {s.store_name || s.name || s.title || s.id}
                                            </option>
                                        ))}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Type</span>
                                    <select
                                        value={selectedType}
                                        onChange={(e) => setSelectedType(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="2">Product</option>
                                        <option value="1">Service</option>
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Income Account</span>
                                    <select
                                        value={selectedIncomeAccount}
                                        onChange={(e) => setSelectedIncomeAccount(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select income account --</option>
                                        {incomeAccounts.map((account) => {
                                            const optionValue = account?.id || account?.value || account?.account_id || account?.gl_code || "";
                                            const optionLabel = account?.gl_name || account?.name || account?.account_name || account?.title || optionValue;
                                            return (
                                                <option key={optionValue || JSON.stringify(account)} value={optionValue}>
                                                    {optionLabel}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>COGS Account</span>
                                    <select
                                        value={selectedCogsAccount}
                                        onChange={(e) => setSelectedCogsAccount(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select COGS account --</option>
                                        {cogsAccounts.map((account) => {
                                            const optionValue = account?.id || account?.value || account?.account_id || account?.gl_code || "";
                                            const optionLabel = account?.gl_name || account?.name || account?.account_name || account?.title || optionValue;
                                            return (
                                                <option key={optionValue || JSON.stringify(account)} value={optionValue}>
                                                    {optionLabel}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Payable Account</span>
                                    <select
                                        value={selectedPayableAccount}
                                        onChange={(e) => setSelectedPayableAccount(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select payable account --</option>
                                        {payableAccounts.map((account) => {
                                            const optionValue = account?.id || account?.value || account?.account_id || account?.gl_code || "";
                                            const optionLabel = account?.gl_name || account?.name || account?.account_name || account?.title || optionValue;
                                            return (
                                                <option key={optionValue || JSON.stringify(account)} value={optionValue}>
                                                    {optionLabel}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Receivable Account</span>
                                    <select
                                        value={selectedReceivableAccount}
                                        onChange={(e) => setSelectedReceivableAccount(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select receivable account --</option>
                                        {receivableAccounts.map((account) => {
                                            const optionValue = account?.id || account?.value || account?.account_id || account?.gl_code || "";
                                            const optionLabel = account?.gl_name || account?.name || account?.account_name || account?.title || optionValue;
                                            return (
                                                <option key={optionValue || JSON.stringify(account)} value={optionValue}>
                                                    {optionLabel}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Classification</span>
                                    <select
                                        value={selectedClassification}
                                        onChange={(e) => setSelectedClassification(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select classification --</option>
                                        {stockClassifications.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name || item.title || item.id}
                                            </option>
                                        ))}
                                    </select>
                                </label>

                                <label className={classes.uploadField}>
                                    <span className={classes.uploadLabel}>Category</span>
                                    <select
                                        value={selectedCategory}
                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                        className={classes.selectField}
                                    >
                                        <option value="">-- Select category --</option>
                                        {stockCategories.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name || item.title || item.id}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>

                            <label className={classes.uploadField}>
                                <span className={classes.uploadLabel}>Choose Excel or CSV file</span>
                                <input
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={handleFileSelection}
                                />
                            </label>

                            {uploadFile && (
                                <div className={classes.fileInfo}>
                                    Selected file: <strong>{uploadFile.name}</strong>
                                </div>
                            )}

                            <div className={classes.modalActions}>
                                <button className={classes.cancelButton} onClick={handleCloseUploadModal}>
                                    Cancel
                                </button>
                                <button
                                    className={classes.submitButton}
                                    onClick={handleSubmitUploadedProducts}
                                    disabled={uploadingProducts}
                                >
                                    {uploadingProducts ? "Submitting..." : "Submit Products"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Settings;